import { render, staticRenderFns } from "./ProductionOrderTable.vue?vue&type=template&id=b4d1fc2e&scoped=true&"
import script from "./ProductionOrderTable.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOrderTable.vue?vue&type=style&index=0&id=b4d1fc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d1fc2e",
  null
  
)

export default component.exports